import { takeLatest, put } from 'redux-saga/effects';
import { getDescriptiveFitDetails, appNotify, setDescriptiveFitDetails } from 'store/actions';
import { postWithTokenV2 } from 'api/network';

export function* getDescriptiveFitDetailsSaga() {
  yield takeLatest(getDescriptiveFitDetails, function* ({ payload }) {
    try {
      const details = yield postWithTokenV2(`/api/icbm/descriptiveFitDetails`, payload.txnOppIds);

      const detailsString = details.join('\r\n');
      const formatted = detailsString.replace(/\\r\\n/gm, '\r\n');

      yield put(setDescriptiveFitDetails(formatted));
    } catch (error) {
      yield put(appNotify(`Failed to fetch descriptiveFitDetails: ${error.message}`, 'error'));
    }
  });
}